import { getStorageItem, setStorageItem } from '@/shared/helpers/storage';
import { IonButton, IonCol, IonContent, IonGrid, IonModal, IonRow } from '@ionic/react';
import { useEffect, useState } from 'react';
import styles from './CookieModal.module.css';
import { t } from 'i18next';
import LanguageSelector from '@/shared/components/LanguageSelector/LanguageSelector';

const CookieModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const acceptEssentialCookies = () => {
    setIsOpen(false);
    setStorageItem('cookieConsent', 'true');
    setStorageItem('cookieConsentDate', new Date().toISOString());
  };

  useEffect(() => {
    const getInitalCookieConsent = async () => {
      const storedCookieConsent = await getStorageItem('cookieConsent');

      if (!storedCookieConsent) {
        setIsOpen(true);
      }
    };
    void getInitalCookieConsent();
  }, []);

  return (
    <IonModal backdropDismiss={false} isOpen={isOpen} className={styles.modal}>
      <IonContent>
        <IonGrid className={styles.cookieGrid}>
          <IonRow>
            <IonCol>
              <h3 className={styles.cookieHeader}>{t('cookie.banner.title')}</h3>
            </IonCol>
            <div className={styles.languageSelectorWrapper}>
              <LanguageSelector />
            </div>
          </IonRow>
          <IonRow>
            <IonCol>
              <p className={styles.paragraph}>{t('cookie.banner.content')}</p>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol className={styles.acceptAllButton}>
              <IonButton onClick={acceptEssentialCookies}>{t('cookie.banner.button.text')}</IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonModal>
  );
};

export default CookieModal;
